import { Component, OnInit, ViewChild, DebugNode } from '@angular/core';
import { SchoolProfileService } from './schoolprofile.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from "@angular/router";
declare var $: any;

@Component({
  selector: 'app-schoolprofile',
  templateUrl: './schoolprofile.component.html',
  styleUrls: ['./schoolprofile.component.css']
})
export class SchoolprofileComponent implements OnInit {
  HashCode: string;
  data: Array<any>;
  responseData:any;
  TrusteeDetail: Array<any>;
  PrincipalDetail: Array<any>;
  OwnerDetail:  Array<any>;
  schoolname:any;
  StandardDetail: Array<any>;
  documentList: Array<any>;
  InfraStructureDetail: Array<any>;
  EmployeeTypeDetail: Array<any>;
  EmployeeQualificationDetail: Array<any>;
  dropDownData: any;
  ClassRoomDetail:Array<any>;
  yearlist: any;
  yearid: any;

  constructor(private service: SchoolProfileService, private toastr: ToastrService, private spinner: NgxSpinnerService, private router: Router, private rout: ActivatedRoute) { 
  }

  ngOnInit(): void {
    if (this.rout.snapshot.paramMap.has('ID')) {
      this.HashCode = this.rout.snapshot.paramMap.get('ID');
        this.getSchoolProfile(localStorage.getItem("yearID"));
        this.fillyear();
        this.schoolname = "- ("+ localStorage.getItem("SchoolName") +")";
    } else {
      this.router.navigate(['/registrationlist']);
      this.spinner.hide();
    }
  }
  getSchoolProfile(yearid) {
    this.spinner.show();
    const data = {
      HashCode: this.HashCode,
      YearID: yearid
    };
    this.service.getSchoolProfile(data)
      .subscribe(data => {
        this.spinner.hide();
        this.responseData = data;
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
          return
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/registrationlist']);
          return
        }
        else {
          this.data = this.responseData;
          this.TrusteeDetail = this.data["TrusteeList"];
          this.PrincipalDetail = this.data["PrincipalList"];
          this.OwnerDetail = this.data["OwnerList"];
          this.StandardDetail = this.data["StandardList"];
          this.documentList = this.data["DocumentList"];
          this.InfraStructureDetail = this.data["InfrastructureList"];
          this.EmployeeTypeDetail=this.data["EmployeeTypeList"];
          this.EmployeeQualificationDetail=this.data["EmployeeQualificationDetail"];
          this.ClassRoomDetail=this.data["ClassRoomDetail"];
          
          for (var i = 0; i < this.documentList.length; i++) {
            if (this.documentList[i]["Extension"] != ".jpg" && this.documentList[i]["Extension"] != ".jpeg"
              && this.documentList[i]["Extension"] != ".png") {
              this.documentList[i]["downloadURL"] = "assets/images/pdfimage.jpg";
            } else {
              this.documentList[i]["downloadURL"] = this.documentList[i]["ViewURL"];
            }
          }
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }

  fillyear()
  {
    const data = {
    };
    this.service.FillYear(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.yearlist = this.dropDownData.dropdownlist;
        this.yearid=localStorage.getItem("yearID");
      });
  }
}
